'use client';

import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { paths } from '../routes';
import { useEffect } from 'react';

const RegistrationSuccessModal = ({ closeModal }) => {
	const navigate = useNavigate();

	const handleOkClick = () => {
		closeModal();
		navigate(paths.LOGIN);
	};

	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		// closeModal();
	// 		// navigate(paths.LOGIN);
	// 	}, 5000);

	// 	return () => clearTimeout(timer);
	// }, []);

	return (
		<div className='fixed inset-0 z-50 overflow-y-auto'>
			<div className='flex min-h-screen items-center justify-center p-4'>
				{/* Updated backdrop with visibility */}
				<div
					className='fixed inset-0 bg-black bg-opacity-50 z-40'
					onClick={closeModal}></div>

				<div className='relative bg-white rounded-xl shadow-xl max-w-md w-full p-6 text-center z-50'>
					<div className='flex items-center justify-between mb-4'>
						<div></div>
						<button
							onClick={closeModal}
							className='p-1 rounded-lg text-gray-400 hover:text-gray-500 hover:bg-gray-100 transition-colors'>
							<XMarkIcon className='h-5 w-5' />
						</button>
					</div>
					<div className='w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4'>
						<CheckCircleIcon className='h-8 w-8 text-green-600' />
					</div>
					<h3 className='text-lg font-medium text-gray-900 mb-2'>
						Registration Successful!
					</h3>
					<p className='text-sm text-gray-600 mb-6'>
						Please check your email for your credentials. You'll
						need them to log in to your account.
					</p>
					<button
						onClick={handleOkClick}
						className='btn-primary w-full'>
						OK
					</button>
				</div>
			</div>
		</div>
	);
};

export default RegistrationSuccessModal;
